import { AIInsightsApiGetAIInsightsRequest } from '@itsrever/rever-api'
import { skipToken, useQuery } from '@tanstack/react-query'
import { aiInsightsApi } from '@/infrastructure/api/ai-insights/ai-insights'

export const useReturnRateInsights = ({
  ecommerceId,
  language
}: AIInsightsApiGetAIInsightsRequest) => {
  return useQuery({
    queryKey: ['return-rate-insights', ecommerceId, language],
    queryFn:
      ecommerceId !== undefined
        ? async () => {
            const { data } = await aiInsightsApi.getAIInsights({
              ecommerceId,
              language
            })

            return data
          }
        : skipToken,
    staleTime: Infinity
  })
}
